/*
  ANOM — make shoppers choose a size. RUW Marketing, 2026-09-28.

  The theme pre-selects the first size (28), so a fast tap on Add to Cart orders a 28.
  On product pages opened without ?variant= (a link to a specific size keeps it), the Size
  buttons show no selection and every Add to Cart reads "Select a size" until one is tapped.
  The theme's variant logic is untouched: the radio stays checked underneath, we only gate
  the button and the visual state.
*/
(function () {
  if (window.__anomSizePick) return;
  window.__anomSizePick = true;
  if (/[?&]variant=/.test(location.search)) return;

  function sizeFieldset() {
    var sets = document.querySelectorAll('variant-radios fieldset, variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && /^\s*size\b/i.test(lg.textContent)) return sets[i];
    }
    return null;
  }

  function init() {
    var fs = sizeFieldset();
    if (!fs || fs.querySelectorAll('input[type="radio"]').length < 2) return;
    var root = document.documentElement;
    fs.setAttribute('data-anom-size', '');
    root.classList.add('anom-need-size');

    var buttons = Array.prototype.slice.call(document.querySelectorAll('button[name="add"]'));
    var saved = buttons.map(function (b) {
      var l = b.querySelector('.button__label');
      return l ? l.textContent : null;
    });
    buttons.forEach(function (b) {
      var l = b.querySelector('.button__label');
      if (l) l.textContent = 'Select a size';
    });

    var hint = document.createElement('p');
    hint.className = 'anom-size-hint';
    hint.setAttribute('role', 'alert');
    hint.hidden = true;
    hint.textContent = 'Pick your waist size first.';
    fs.appendChild(hint);

    function picked() {
      if (!root.classList.contains('anom-need-size')) return;
      root.classList.remove('anom-need-size');
      hint.hidden = true;
      buttons.forEach(function (b, i) {
        var l = b.querySelector('.button__label');
        if (l && l.textContent === 'Select a size' && saved[i] != null) l.textContent = saved[i];
      });
    }

    fs.addEventListener('change', picked);
    fs.addEventListener('click', function (e) {
      if (e.target.closest('label, input')) picked();
    });

    document.addEventListener('click', function (e) {
      if (!root.classList.contains('anom-need-size')) return;
      var b = e.target.closest('button[name="add"]');
      if (!b) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      hint.hidden = false;
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);

    document.addEventListener('submit', function (e) {
      if (!root.classList.contains('anom-need-size')) return;
      var a = e.target && e.target.getAttribute('action');
      if (a && a.indexOf('/cart/add') !== -1 && !e.target.closest('.quick-add-modal, quick-add-modal')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        hint.hidden = false;
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
